<script>
    import appConfig from "../../../app.config";
    // import SwiperCore, {
    //     Thumbs,
    //     Navigation,
    //     Pagination
    // } from "swiper";
    // import {
    //     Swiper,
    //     SwiperSlide
    // } from "swiper/vue";
    // import "swiper/swiper-bundle.css";
    // import {
    //     CountTo
    // } from "vue3-count-to";

    // SwiperCore.use([Thumbs, Navigation, Pagination]);
    export default {
        page: {
            title: "Starter",
            meta: [{
                name: "description",
                content: appConfig.description
            }],
        },
        data() {
            return {
                title: "Starter",
                items: [{
                        text: "Pages",
                        href: "/",
                    },
                    {
                        text: "Starter",
                        active: true,
                    },
                ],
            };
        },
        components: {
            // Swiper,
            // SwiperSlide,
            // CountTo,
        },
        methods: {
            monthly() {
                const highlightedItems = document.querySelectorAll(".month");

                highlightedItems.forEach(function (userItem) {
                    userItem.style.display = "block";
                });
                const highlightedItems2 = document.querySelectorAll(".annual");

                highlightedItems2.forEach(function (userItem) {
                    userItem.style.display = "none";
                });
            },
            anually() {
                const highlightedItems = document.querySelectorAll(".month");

                highlightedItems.forEach(function (userItem) {
                    userItem.style.display = "none";
                });
                const highlightedItems2 = document.querySelectorAll(".annual");

                highlightedItems2.forEach(function (userItem) {
                    userItem.style.display = "block";
                });
            },
        }, 
        mounted() {
            document.documentElement.setAttribute("data-layout-mode", "dark");
            this.monthly();
            // document.getElementById("plan-switch").addEventListener('change', () => {
            //     if (document.getElementById("plan-switch").checked == true) {
            //         this.anually();
            //     } else if (document.getElementById("plan-switch").checked == false) {
            //         this.monthly();
            //     }
            // });
            window.addEventListener('scroll', function (ev) {
                ev.preventDefault();
                var navbar = document.getElementById("navbar");
                if (navbar) {
                    if (document.body.scrollTop >= 50 || document.documentElement.scrollTop >= 50) {
                        navbar.classList.add("is-sticky");
                    } else {
                        navbar.classList.remove("is-sticky");
                    }
                }
            });

            document.querySelector('.currentyear').innerHTML = new Date().getFullYear() + " © Repo Alnair";
        },
    };
</script>

<template>
    <div class="layout-wrapper landing">
        <nav class="navbar navbar-expand-lg navbar-landing fixed-top" id="navbar">
            <div class="container">
                <a class="navbar-brand" href="">
                    <h1>Repo Alnair</h1>
                    <!-- <img src="@/assets/images/logo-dark.png" class="card-logo card-logo-dark" alt="logo dark" -->
                        <!-- height="17"> -->
                    <!-- <img src="@/assets/images/logo-light.png" class="card-logo card-logo-light" alt="logo light" -->
                        <!-- height="17"> -->
                </a>
                <button class="navbar-toggler py-0 fs-20 text-body" type="button" data-bs-toggle="collapse"
                    data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                    aria-expanded="false" aria-label="Toggle navigation">
                    <i class="mdi mdi-menu"></i>
                </button>

                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul class="navbar-nav mx-auto mt-2 mt-lg-0" id="navbar-example">
                        <li class="nav-item">
                            <a class="nav-link active" href="#hero">Home</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#services">Services</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" href="#features">Features</a>
                        </li>
                        <!-- <li class="nav-item"> -->
                            <!-- <a class="nav-link" href="#plans">Plans</a> -->
                        <!-- </li> -->
                        <!-- <li class="nav-item"> -->
                            <!-- <a class="nav-link" href="#reviews">Reviews</a> -->
                        <!-- </li> -->
                        <!-- <li class="nav-item"> -->
                            <!-- <a class="nav-link" href="#team">Team</a> -->
                        <!-- </li> -->
                        <!-- <li class="nav-item"> -->
                            <!-- <a class="nav-link" href="#contact">Contact</a> -->
                        <!-- </li> -->
                    </ul>

                    <!-- <div class=""> -->
                        <!-- <router-link to="/auth/signin-basic" -->
                            <!-- class="btn btn-link fw-medium text-decoration-none text-dark">Sign -->
                            <!-- in</router-link> -->
                        <!-- <router-link to="/auth/signup-basic" class="btn btn-primary">Sign Up</router-link> -->
                    <!-- </div> -->
                </div>

            </div>
        </nav>
        <!-- end navbar -->

        <!-- start hero section -->
        <section class="section pb-0 hero-section" id="hero">
            <div class="bg-overlay bg-overlay-pattern"></div>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8 col-sm-10">
                        <div class="text-center mt-lg-5 pt-5">
                            <h1 class="display-6 fw-semibold mb-3 lh-base">Konsisten, maka kita akan meraih keberhasilan yang sebenarnya<br>    
                                <span class="text-success">-Repo Alnair </span></h1>
                            <p class="lead text-muted lh-base">Solusi dalam pemanfaatan teknologi informasi tepat guna</p>

                            <!-- <div class="d-flex gap-2 justify-content-center mt-4"> -->
                                <!-- <a href="auth-signup-basic.html" class="btn btn-primary">Get Started <i -->
                                        <!-- class="ri-arrow-right-line align-middle ms-1"></i></a> -->
                                <!-- <router-link to="/pages/pricing" class="btn btn-soft-primary">View Plans <i -->
                                        <!-- class="ri-eye-line align-middle ms-1"></i></router-link> -->
                            <!-- </div> -->
                        </div>

                        <!-- <div class="mt-4 mt-sm-5 pt-sm-5 mb-sm-n5 demo-carousel"> -->
                            <!-- <div class="demo-img-patten-top d-none d-sm-block"> -->
                                <!-- <img src="@/assets/images/landing/img-pattern.png" class="d-block img-fluid" alt="..."> -->
                            <!-- </div> -->
                            <!-- <div class="demo-img-patten-bottom d-none d-sm-block"> -->
                                <!-- <img src="@/assets/images/landing/img-pattern.png" class="d-block img-fluid" alt="..."> -->
                            <!-- </div> -->
                            <!-- <div class="carousel slide carousel-fade" data-bs-ride="carousel"> -->
                                <!-- <div class="carousel-inner shadow-lg p-2 bg-white rounded"> -->
                                    <!-- <div class="carousel-item active" data-bs-interval="2000"> -->
                                        <!-- <img src="@/assets/images/demos/default.png" class="d-block w-100" alt="..."> -->
                                    <!-- </div> -->
                                    <!-- <div class="carousel-item" data-bs-interval="2000"> -->
                                        <!-- <img src="@/assets/images/demos/saas.png" class="d-block w-100" alt="..."> -->
                                    <!-- </div> -->
                                    <!-- <div class="carousel-item" data-bs-interval="2000"> -->
                                        <!-- <img src="@/assets/images/demos/material.png" class="d-block w-100" alt="..."> -->
                                    <!-- </div> -->
                                    <!-- <div class="carousel-item" data-bs-interval="2000"> -->
                                        <!-- <img src="@/assets/images/demos/minimal.png" class="d-block w-100" alt="..."> -->
                                    <!-- </div> -->
                                    <!-- <div class="carousel-item" data-bs-interval="2000"> -->
                                        <!-- <img src="@/assets/images/demos/creative.png" class="d-block w-100" alt="..."> -->
                                    <!-- </div> -->
                                    <!-- <div class="carousel-item" data-bs-interval="2000"> -->
                                        <!-- <img src="@/assets/images/demos/modern.png" class="d-block w-100" alt="..."> -->
                                    <!-- </div> -->
                                    <!-- <div class="carousel-item" data-bs-interval="2000"> -->
                                        <!-- <img src="@/assets/images/demos/interactive.png" class="d-block w-100" -->
                                            <!-- alt="..."> -->
                                    <!-- </div> -->
                                <!-- </div> -->
                            <!-- </div> -->
                        <!-- </div> -->

                    </div>
                </div>
                <!-- end row -->
            </div>
            <!-- end container -->
            <div class="position-absolute start-0 end-0 bottom-0 hero-shape-svg">
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 1440 120">
                    <g mask="url(&quot;#SvgjsMask1003&quot;)" fill="none">
                        <path d="M 0,118 C 288,98.6 1152,40.4 1440,21L1440 140L0 140z">
                        </path>
                    </g>
                </svg>
            </div>
            <!-- end shape -->
        </section>
        <!-- end hero section -->

        <!-- start services -->
        <section class="section" id="services">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <div class="text-center mb-5">
                            <h1 class="mb-3 ff-secondary fw-semibold lh-base">A Digital solution</h1>
                            <p class="text-muted">Internet of Things Projects</p>
                        </div>
                    </div>
                    <!-- end col -->
                </div>
                <!-- end row -->

                <div class="row g-3">
                    <div class="col-lg-4">
                        <div class="d-flex p-3">
                            <div class="flex-shrink-0 me-3">
                                <div class="avatar-sm icon-effect">
                                    <div class="avatar-title bg-transparent text-success rounded-circle">
                                        <i class="ri-pencil-ruler-2-line fs-36"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <h5 class="fs-18">Creative Design</h5>
                                <p class="text-muted my-3 ff-secondary">The creative design includes designs that are
                                    unique, effective and memorable.</p>
                                <div>
                                    <!-- <a href="#" class="fs-13 fw-medium">Learn More <i -->
                                            <!-- class="ri-arrow-right-s-line align-bottom"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end col -->
                    <div class="col-lg-4">
                        <div class="d-flex p-3">
                            <div class="flex-shrink-0 me-3">
                                <div class="avatar-sm icon-effect">
                                    <div class="avatar-title bg-transparent text-success rounded-circle">
                                        <i class="ri-palette-line fs-36"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <h5 class="fs-18">Unlimited Colors</h5>
                                <p class="text-muted my-3 ff-secondary">The collection of rules and guidelines which
                                    designers use to communicate with users through appealing.</p>
                                <div>
                                    <!-- <a href="#" class="fs-13 fw-medium">Learn More <i -->
                                            <!-- class="ri-arrow-right-s-line align-bottom"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end col -->
                    <div class="col-lg-4">
                        <div class="d-flex p-3">
                            <div class="flex-shrink-0 me-3">
                                <div class="avatar-sm icon-effect">
                                    <div class="avatar-title bg-transparent text-success rounded-circle">
                                        <i class="ri-lightbulb-flash-line fs-36"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <h5 class="fs-18">Strategy Solutions</h5>
                                <p class="text-muted my-3 ff-secondary">Business development firm that provides
                                    strategic planning, market research services and project.</p>
                                <div>
                                    <!-- <a href="#" class="fs-13 fw-medium">Learn More <i -->
                                            <!-- class="ri-arrow-right-s-line align-bottom"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end col -->
                    <div class="col-lg-4">
                        <div class="d-flex p-3">
                            <div class="flex-shrink-0 me-3">
                                <div class="avatar-sm icon-effect">
                                    <div class="avatar-title bg-transparent text-success rounded-circle">
                                        <i class="ri-customer-service-line fs-36"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <h5 class="fs-18">Awesome Support</h5>
                                <p class="text-muted my-3 ff-secondary">Awesome Support is the most versatile and
                                    feature-rich support plugin for all version.</p>
                                <div>
                                    <!-- <a href="#" class="fs-13 fw-medium">Learn More <i -->
                                            <!-- class="ri-arrow-right-s-line align-bottom"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end col -->
                    <div class="col-lg-4">
                        <div class="d-flex p-3">
                            <div class="flex-shrink-0 me-3">
                                <div class="avatar-sm icon-effect">
                                    <div class="avatar-title bg-transparent text-success rounded-circle">
                                        <i class="ri-stack-line fs-36"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <h5 class="fs-18">Truly Multipurpose</h5>
                                <p class="text-muted my-3 ff-secondary">You usually get a broad range of options to play
                                    with. This enables you to use a single theme across multiple.</p>
                                <div>
                                    <!-- <a href="#" class="fs-13 fw-medium">Learn More <i -->
                                            <!-- class="ri-arrow-right-s-line align-bottom"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end col -->
                    <div class="col-lg-4">
                        <div class="d-flex p-3">
                            <div class="flex-shrink-0 me-3">
                                <div class="avatar-sm icon-effect">
                                    <div class="avatar-title bg-transparent text-success rounded-circle">
                                        <i class="ri-settings-2-line fs-36"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <h5 class="fs-18">Easy to customize</h5>
                                <p class="text-muted my-3 ff-secondary">Personalise your own website, no matter what
                                    theme and what customization options.</p>
                                <div>
                                    <!-- <a href="#" class="fs-13 fw-medium">Learn More <i -->
                                            <!-- class="ri-arrow-right-s-line align-bottom"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end col -->

                    <div class="col-lg-4">
                        <div class="d-flex p-3">
                            <div class="flex-shrink-0 me-3">
                                <div class="avatar-sm icon-effect">
                                    <div class="avatar-title bg-transparent text-success rounded-circle">
                                        <i class="ri-slideshow-line fs-36"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <h5 class="fs-18">Responsive & Clean Design</h5>
                                <p class="text-muted my-3 ff-secondary">Responsive design is a graphic user interface
                                    (GUI) design approach used to create content.</p>
                                <div>
                                    <!-- <a href="#" class="fs-13 fw-medium">Learn More <i -->
                                            <!-- class="ri-arrow-right-s-line align-bottom"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end col -->
                    <div class="col-lg-4">
                        <div class="d-flex p-3">
                            <div class="flex-shrink-0 me-3">
                                <div class="avatar-sm icon-effect">
                                    <div class="avatar-title bg-transparent text-success rounded-circle">
                                        <i class="ri-google-fill fs-36"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <h5 class="fs-18">Google Font Collection</h5>
                                <p class="text-muted my-3 ff-secondary">Google Fonts is a collection of 915 fonts, all
                                    available to use for free on your website.</p>
                                <div>
                                    <!-- <a href="#" class="fs-13 fw-medium">Learn More <i -->
                                            <!-- class="ri-arrow-right-s-line align-bottom"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end col -->
                    <div class="col-lg-4">
                        <div class="d-flex p-3">
                            <div class="flex-shrink-0 me-3">
                                <div class="avatar-sm icon-effect">
                                    <div class="avatar-title bg-transparent text-success rounded-circle">
                                        <i class="ri-briefcase-5-line fs-36"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-grow-1">
                                <h5 class="fs-18">Top Industry Specialists</h5>
                                <p class="text-muted my-3 ff-secondary">An industrial specialist works with industrial
                                    operations to ensure that manufacturing facilities work.</p>
                                <div>
                                    <!-- <a href="#" class="fs-13 fw-medium">Learn More <i -->
                                            <!-- class="ri-arrow-right-s-line align-bottom"></i></a> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end col -->
                </div>
                <!-- end row -->
            </div>
            <!-- end container -->
        </section>
        <!-- end services -->

        <!-- start features -->
        <section class="section bg-light py-5" id="features">
            <div class="container">
                <div class="row align-items-center gy-4">
                    <!-- <div class="col-lg-6 col-sm-7 mx-auto"> -->
                        <!-- <div> -->
                            <!-- <img src="@/assets/images/landing/features/img-1.png" alt="" class="img-fluid mx-auto"> -->
                        <!-- </div> -->
                    <!-- </div> -->
                    <div class="col-lg-6 mx-auto">
                        <div class="text-muted">
                            <div class="avatar-sm icon-effect mb-4">
                                <div class="avatar-title bg-transparent rounded-circle text-success h1">
                                    <i class="ri-collage-line fs-36"></i>
                                </div>
                            </div>
                            <h3 class="mb-3 fs-20">Huge collection of internet service</h3>
                            <p class="mb-4 ff-secondary fs-16">Collection service specialize in displaying many elements
                                of data enchanded from many sensors, Insights & Big Data Analysis</p>

                            <div class="row pt-3">
                                <div class="col-3">
                                    <div class="text-center">
                                        <h4>Smart Home</h4>
                                        <p>Secure Access Monitor, Schedule & Control</p>
                                    </div>
                                </div>
                                <div class="col-3">
                                    <div class="text-center">
                                        <h4>Smart City</h4>
                                        <p>Surveillance Systems, Boomgate Systems, Parking Systems & Electronic Tickets</p>
                                    </div>
                                </div>
                                <div class="col-4">
                                    <div class="text-center">
                                        <h4>Smart Farming</h4>
                                        <p>Climate, Weather & Environment Monitoring, Forecasting & Data Analysis to increace agricultural productivity</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end col -->
                </div>
                <!-- end row -->
            </div>
            <!-- end container -->
        </section>
        <!-- end features -->

        <!-- Start footer -->
        <footer class="custom-footer bg-dark py-5 position-relative">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4 mt-4">
                        <div>
                            <div>
                                <h1>Repo Alnair <sup class="text-muted">&reg;</sup></h1>
                                <!-- <img src="@/assets/images/logo-light.png" alt="logo light" height="17"> -->
                            </div>
                            <div class="mt-4 fs-13">
                                <p>Solusi dalam pemanfaatan teknologi informasi tepat guna</p>
                                <p class="ff-secondary">Internet of Things Service and Big Data Analysis.</p>
                                <!-- <p class="text-muted">&copy; Repo Alnair, 2022</p> -->
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row text-center text-sm-start align-items-center mt-5">
                    <div class="col-sm-6">
                        <p class="copy-rights mb-0 currentyear"></p>
                    </div>
                </div>


            </div>
        </footer>
        <!-- end footer -->

    </div>
</template>